import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {
  BORDER_COLOR,
  PAYMENTS_BACKGROUND_COLOR,
  PAYMENT_CARD_COLOR,
  APP,
  DEFAULT_WHITE_COLOR,
  APP_PRIMARY_COLOR
} from 'src/style/variable';

export const textFieldStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiCheckbox-root': {
        backgroundColor: 'rgba(0, 0, 0, 0)'
      },
      '& .MuiSvgIcon-root': {
        height: '20px',
        width: '20px'
      },
      '$ .MuiFormControl-marginDense': {
        marginTop: '0px'
      }
    },
    checkBox: {
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    form: {
      '& .MuiFormControl-marginDense': {
        marginTop: '0px'
      },
      marginTop: '0px'
    },
    adornedEnd: {
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: '0px',
        width: '100%'
      },
      paddingRight: '0px'
    },
    dateInputStyle: {
      width: '200px',
      height: '2.3rem',
      borderRadius: '4px',
      paddingRight: '0px',
      marginTop: '0 !important',
      fontSize: '0.3rem'
    },
    buttonStyle: {
      height: '2.3rem',
      width: '6rem',
      paddingLeft: 0,
      paddingRight: 0,
      textTransform: 'capitalize'
    },
    buttonRemainderStyle: {
      height: '2.3rem',
      width: '10rem',
      paddingLeft: 0,
      paddingRight: 0,
      textTransform: 'capitalize'
    },
    applyButtonStyles: {
      backgroundColor: PAYMENT_CARD_COLOR,
      border: 'none',
      color: 'white',
      lineHeight: '1rem',
      '&:hover': {
        backgroundColor: PAYMENT_CARD_COLOR
      }
    },
    resetButtonStyles: {
      lineHeight: '1rem',
      '&:hover': {
        backgroundColor: BORDER_COLOR
      }
    },
    menuItemsMainView: {
      width: '300px'
    },
    dropDownMainView: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    clinicNameAddressView: {
      flex: 1,
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: '1.2rem',
      color: 'black'
    },
    clinicAddress: {
      fontSize: '0.8rem',
      color: '#777777'
    },
    checkBoxMainView: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    primaryTextColor: {
      color: APP_PRIMARY_COLOR
    },
    patientNameStyles: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        color: PAYMENTS_BACKGROUND_COLOR
      }
    },
    tagsGuarantor: {
      whiteSpace: 'nowrap',
      color: DEFAULT_WHITE_COLOR,
      borderRadius: '4px',
      padding: '4px',
      marginLeft: '8px',
      fontSize: '0.8125rem',
      textAlign: 'center'
    },
    tagsGuarantorFn: {
      backgroundColor: APP.COLOR.NOTICE_TYPE.FN
    },
    tagsGuarantorPd: {
      backgroundColor: APP.COLOR.NOTICE_TYPE.PD
    },
    notification_delivery_status_sent: {
      backgroundColor: APP.COLOR.NOTIFICATION_DELIVERY_STATUS.SENT
    },
    notification_delivery_status_failed: {
      backgroundColor: APP.COLOR.NOTIFICATION_DELIVERY_STATUS.FAILED
    },
    notification_delivery_status_ignored: {
      backgroundColor: APP.COLOR.NOTIFICATION_DELIVERY_STATUS.IGNORED
    },
    notification_delivery_status_pending: {
      backgroundColor: APP.COLOR.NOTIFICATION_DELIVERY_STATUS.PENDING
    },
    activePatientNameStyles: {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: PAYMENTS_BACKGROUND_COLOR
    },
    gridWrapper: {
      height: `calc(100vh - ${theme.mixins.toolbar.minHeight} - 10px)`,
      overflow: 'auto',
      backgroundColor: '#ffffff'
    },
    tableWrapper: {
      height: `calc(100vh - ${theme.mixins.toolbar.minHeight} - 150px)`
      // overflow: 'auto'
    },
    displayFlex: {
      // flex: 1,
      display: 'flex',
      alignItems: 'center'
    },
    contentCenter: {
      justifyContent: 'center',
      textAlign: 'center',
      width: '50px',
      fontSize: '1.8rem'
    },
    paddingLeft: {
      paddingLeft: '1rem'
    },
    remainder: {
      cursor: 'pointer'
    },
    remainderHeader: {
      fontSize: '1.2rem',
      padding: '1rem 1.3rem'
    },
    MainTablepatientName: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '50%'
    },
    downloadButtonStyles: {
      backgroundColor: APP_PRIMARY_COLOR,
      border: 'none',
      color: 'white',
      '&:hover': {
        backgroundColor: APP_PRIMARY_COLOR
      },
      height: '2.3rem',
      width: 'auto',
      textTransform: 'capitalize'
    },
    displayFlexColumn: {
      // flex: 1,
      display: 'flex',
      flexDirection: 'column'
      // alignItems: 'center'
    },
    linkButton: {
      whiteSpace: 'nowrap',
      lineHeight: '1.25rem',
      '&:hover': {
        color: APP_PRIMARY_COLOR,
        textDecoration: 'underline'
      }
    },
    marginTop6: {
      marginTop: '6px'
    }
  })
);
